module.exports = __webpack_public_path__ + "96849c9a9a6685ea0fe5ad8f83618ee7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/cat-ears-s.png
// module id = 2654
// module chunks = 0